export enum FeedbackReasonValues {
  Other = 'other',
  IncorectStructure = 'wrong-rt',
  WrongEM = 'wrong-em',
  IncorectProject = 'wrong-project',
  ContactPRTeam = 'contact-pr-team',
  MissingRole = 'missing-role',
}
